import { type CSSProperties } from 'react';
import styles from './OpacityInput.module.css';

export interface OpacityInputProps {
  /** 0–1 */
  value: number;
  onChange: (value: number) => void;
  /** Hex color to show in the gradient track (defaults to black) */
  color?: string;
}

/**
 * OpacityInput — a checkerboard-backed slider showing opacity as a 0–100% gradient.
 * The track fades from the active color (left) to transparent (right), with a
 * checkerboard underneath so true transparency is visible.
 *
 * @example
 * <OpacityInput value={fillOpacity} onChange={setFillOpacity} color={fillColor} />
 */
export function OpacityInput({ value, onChange, color = '#000000' }: OpacityInputProps) {
  const pct = Math.round(value * 100);

  return (
    <div className={styles.root}>
      <span className={styles.label}>Opacity</span>
      <div className={styles.track} style={{ '--opacity-color': color } as CSSProperties}>
        <div className={styles.trackFill} />
        <input
          type="range"
          min={0}
          max={1}
          step={0.01}
          value={value}
          className={styles.input}
          onChange={(e) => onChange(Number(e.target.value))}
        />
      </div>
      <span className={styles.value}>{pct}%</span>
    </div>
  );
}
